// CookieConsent — banner minimale di consenso cookie/analytics.
//
// Visibile SOLO se il flag GATSBY_FEATURE_COOKIE_BANNER è attivo e l'utente non
// ha ancora scelto (localStorage). Accetta → abilita PostHog; Rifiuta → opt-out.
// Con il flag disattivo (default) non renderizza nulla → banner invisibile.

import React from 'react';
import { cookieBannerEnabled, getConsent, acceptCookies, declineCookies } from '../analytics/posthog';

export default function CookieConsent() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    if (cookieBannerEnabled() && !getConsent()) setVisible(true);
  }, []);

  if (!visible) return null;

  const done = (fn) => { fn(); setVisible(false); };

  return (
    <div style={{
      position: 'fixed', left: 16, right: 16, bottom: 16, zIndex: 3000,
      maxWidth: 560, margin: '0 auto',
      background: 'white', border: '1px solid var(--neutral-200, #e8e8e0)', borderRadius: 12,
      boxShadow: '0 12px 40px rgba(0,0,0,0.18)', padding: '14px 16px',
      display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12,
      fontFamily: "var(--font-sans, 'IBM Plex Sans', system-ui, sans-serif)",
    }}>
      <div style={{ flex: 1, minWidth: 220, fontSize: 13, color: 'var(--neutral-700, #3a3a34)', lineHeight: 1.5 }}>
        Usiamo cookie tecnici e strumenti di analisi per migliorare la piattaforma.{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--brand-teal, #2D9B9B)', fontWeight: 600 }}>Privacy Policy</a>.
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          onClick={() => done(declineCookies)}
          style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid var(--neutral-300, #d4d4c8)', background: 'white', color: 'var(--neutral-700, #3a3a34)', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}
        >
          Rifiuta
        </button>
        <button
          onClick={() => done(acceptCookies)}
          style={{ padding: '8px 14px', borderRadius: 8, border: 'none', background: 'var(--brand-teal, #2D9B9B)', color: 'white', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}
        >
          Accetta
        </button>
      </div>
    </div>
  );
}
